// A trailer (or railcar) "number" that is really a blank: "NA", "n/a", "none",
// "000". Punctuation and case are stripped first so "n/a", "N.A.", and "- -"
// all collapse to the same token.
//
// The driverApi lambda keeps its own copy of this list
// (amplify/backend/function/driverApi/src/endpoints/checkin.js) because it
// cannot import client code. Change both together.
const PLACEHOLDER_TRAILERS = new Set([
  "",
  "na",
  "n",
  "no",
  "none",
  "nil",
  "null",
  "nothing",
  "notrailer",
  "x",
  "xx",
  "xxx",
  "tbd",
  "unknown",
  "unk",
  "pending",
  "empty",
  "blank",
]);

export const isPlaceholderTrailer = (v) => {
  const token = String(v || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
  return PLACEHOLDER_TRAILERS.has(token) || /^0+$/.test(token);
};
